<template src="./Edit.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import BrandSelect from "@/components/components/BrandSelect"
import EditableField from "@/components/components/EditableField"

const {mapGetters, mapActions} = createNamespacedHelpers('order/edit')

export default {
  name: "OrderEdit",
  components: {
    BrandSelect,
    EditableField,
  },
  data() {
    return {
      showOverlay: false,
      isReady: false,
      orderId: this.$route.params.id,
      editSwitch: {},
      fieldList: [
        {
          key: 'orderId',
          type: 'number',
          label: 'Номер',
        },
        {
          key: 'requestId',
          type: 'number',
          label: 'Номер запроса',
        },
        {
          key: 'sortDate',
          type: 'date',
          label: 'Дата сортировки',
        },
        {
          key: 'created',
          type: 'static',
          label: 'Дата заказа',
        },
        {
          key: 'fam',
          type: 'number',
          label: 'FAM',
        },
        {
          key: 'originArticle',
          type: 'text',
          label: 'Артикул',
        },
        {
          key: 'modelNumber',
          type: 'text',
          label: 'Название модели',
        },
        {
          key: 'descriptionRu',
          type: 'textarea',
          label: 'Описание артикула (ru)',
        },
        {
          key: 'descriptionDe',
          type: 'textarea',
          label: 'Описание интернациональное',
        },
        {
          key: 'requestDescriptionRu',
          type: 'textarea',
          label: 'Описание от клиента',
        },
        {
          key: 'requestDescriptionDe',
          type: 'textarea',
          label: 'Описание для поставщика',
        },
        {
          key: 'articleId',
          type: 'number',
          label: 'Номер артикула',
        },
        {
          key: 'requestArticle',
          type: 'text',
          label: 'Артикул запроса',
        },
        {
          key: 'clientCity',
          type: 'text',
          label: 'Город клиента',
        },
        {
          key: 'maxPrice',
          type: 'number',
          label: 'Цена (EUR)',
        },
        {
          key: 'warehouse',
          type: 'text',
          label: 'Адрес склада',
        },
        {
          key: 'plannedArrivalFrom',
          type: 'number',
          label: 'Срок поставки мин.',
        },
        {
          key: 'plannedArrivalTo',
          type: 'number',
          label: 'Срок поставки макс.',
        },
      ],
      photoFile: {},
      photoNumber: 0,
    }
  },
  methods: {
    ...mapActions(['GET_DATA', 'SAVE']),
    brandsChange(brand) {
      this.DATA['brand-name'] = brand.name
      this.DATA['brandId'] = brand.id
      console.log(this.DATA)
    },
    getFieldLabel(key) {
      for (let i in this.fieldList) {
        if (this.fieldList[i].key === key) {
          return this.fieldList[i].label
        }
      }

      return ''
    },
    save() {
      this.SAVE({th: this})
      return false
    },
    initValue() {
      this.$set(this.DATA, 'newPhotos', {})
      this.$set(this.DATA, 'deletedPhotos', [])
      this.photoNumber = 0
    },
    deletePhotoField(number) {

      this.DATA.newPhotos[number] = null
      this.$forceUpdate()
    },
    deletePhoto(photoId) {
      for (let key in this.DATA.photos) {
        if (this.DATA.photos[key].id === photoId) {
          this.DATA.photos.splice(key, 1)
        }
      }
      this.DATA.deletedPhotos.push(photoId)
    },
    isExistField(number) {

      return this.DATA.newPhotos[number] !== null
    },
    addNewPhotoField() {
      this.photoNumber ++
      // this.DATA.newPhotos.splice(this.DATA.newPhotos.length, 1, [])
      this.$set(this.DATA.newPhotos, this.photoNumber,  [])
      console.log(this.DATA.newPhotos)
    }
  },
  computed: {
    ...mapGetters([
      'DATA',
    ]),
  },
  mounted: function () {
    if (this.$store.getters.getAllowSection.indexOf('order') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }

    this.GET_DATA({th: this});
  },
  created() {
  },
}
</script>

<style scoped>
.left {
  text-align: left;
}
.submit-button {
  text-align: right;
}
.dummy-btn {
  width: 39px;
  height: 22px;
  display: inline-block;
}
.photo {
  max-height: 6em;
}
.label-col {
  text-align: right;
}
</style>

<style>

</style>